import { getContestEntryByUser } from "../../services/ContestEntry";
import { getContestId } from "../../services/ContestSeries";

import {
  FETCH_CONTESTS_SUCCESS,
  FETCH_CONTESTS_REQUEST,
  FETCH_CONTESTS_FAILURE,
  UPDATE_CONTEST_CLOSE,
  ADD_CONTEST_PLAYED,
  OMIT_CONTEST,
  UPDATE_CONTEST,
  FETCH_CONTESTS_STATUS,
  UPDATE_STATUS,
} from "./types";

export const updateContestStatus = () => ({
  type: UPDATE_STATUS,
});

// Util generate poolkey from contest
export const getContestSeriesKey = (contest: any) => {
  const {
    duration,
    assetType,
    instrumentPrices,
    // : [
    //   {
    //     instrument: { assetIdBase },
    //   },
    // ],
  } = contest;

  return `${duration}-${assetType}-${instrumentPrices?.[0]?.instrument?.assetIdBase}`;
};

export const fetchContestsRequests = () => ({
  type: FETCH_CONTESTS_REQUEST,
});

export const fetchContestsSuccess = (contests: any) => ({
  type: FETCH_CONTESTS_SUCCESS,
  payload: contests,
});

export const fetchContestsStatus = (boolean: boolean) => ({
  type: FETCH_CONTESTS_STATUS,
  payload: boolean,
});

export const fetchContestsFailure = (error: any) => ({
  type: FETCH_CONTESTS_FAILURE,
  payload: {
    error,
  },
});

export const fetchPlayedContests = (auth, seriesID) => async (dispatch) => {
  if (!auth || !auth.token || !seriesID) {
    return;
  }

  try {
    const contestEntries = await getContestEntryByUser(auth, seriesID);
    (contestEntries || []).forEach((contestEntry) => {
      const {
        id,
        contestId,
        wager,
        direction,
        status,
        contestType,
        enteredContest,
        entryStatus,
        moonOdds,
        rektOdds,
      } = contestEntry;

      if (["Cancelled", "Removed"].includes(status)) {
        return;
      }

      if (!contestType.includes("OverUnder")) {
        return;
      }

      if (["Cancelled", "Completed"].includes(entryStatus)) {
        return;
      }

      // TODO: Ignore contest entry based on contest duration
      const deltaTime =
        (Date.now() - Date.parse(enteredContest)) / 1000 / 60 / 60; // hours
      if (deltaTime > 24) {
        return;
      }

      const contestPlayAction = addContestPlayed({
        id: contestId,
        entryId: id,
        wager: wager,
        position: direction.toLowerCase(),
        entryStatus,
        whitelabelMoonOdds: moonOdds,
        whitelabelRektOdds: rektOdds,
      });

      dispatch(contestPlayAction);
    });
  } catch (err) {
    console.error("fetch contest played error", err);
  }
};

export const fetchContests =
  (contests: any, series: any) => async (dispatch: any) => {
    dispatch(fetchContestsStatus(false));

    if (contests) {
      dispatch(fetchContestsSuccess(contests));
      dispatch(fetchContestsStatus(true));
      return;
    }

    dispatch(fetchContestsRequests());
    try {
      // TODO: sort series to get the HXRO, BTC, 1m sooner
      const getContests = series
        .filter(
          (s: any) =>
            s.name.includes("BTC/USD") && s.contestDuration === "00:01:00"
        )
        .map(({ id }: { id: any }) =>
          getContestId(id).then((contests: any) =>
            dispatch(fetchContestsSuccess(contests))
          )
        );

      await Promise.all(getContests);
      dispatch(fetchContestsStatus(true));
    } catch (err) {
      console.error("fetch contest failure", err);
      dispatch(fetchContestsFailure(err));
      dispatch(fetchContestsStatus(true));
    }
  };

export const updateContest = (data: any) => (dispatch: any, getState: any) => {
  data.livePrice = data.instrumentPrices?.[0]?.livePrice.blendedPrice;
  data.closePrice = data.instrumentPrices?.[0]?.closePrice.blendedPrice;

  if (data.status === "Closed") {
    const state = getState().contestSeries;
    const contest = state.contests[data.id];
    if (!contest) {
      return;
    }
    const seriesKey = getContestSeriesKey(contest);

    const closed = (state.series[seriesKey] || [])
      .filter((contestId) => {
        const item = state.contests[contestId];
        if (!item) {
          dispatch(omitContest({ seriesKey, idToOmit: contestId }));
          return false;
        }
        return !["Live", "Opened"].includes(item.status);
      })
      .sort(
        (a, b) => Date.parse(a.contestLiveTime) - Date.parse(b.contestLiveTime)
      )
      .slice(0, -3);

    closed.forEach((idToOmit) =>
      dispatch(omitContest({ seriesKey, idToOmit }))
    );
  }

  dispatch(setContestUpdated(data));
};

export const setContestUpdated = (payload: any) => ({
  type: UPDATE_CONTEST,
  payload,
});

export const omitContest = (payload: any) => ({
  type: OMIT_CONTEST,
  payload,
});

export const addContestPlayed = (contest: any) => ({
  type: ADD_CONTEST_PLAYED,
  payload: { contest },
});

export const closeContest = (contestUpdate: any, idToOmit: any) => ({
  type: UPDATE_CONTEST_CLOSE,
  payload: { contestUpdate, idToOmit },
});
